import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useContext } from 'react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { ScrollableContentContext } from '../../ScrollableContent.context';
import './Content.less';
var defaultProps = {
  content: null,
  children: null,
  className: '',
  hideScrollbar: false
};
export default function Content(_ref) {
  var _classNames;
  var content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    hideScrollbar = _ref.hideScrollbar;
  var finalContent = content || children;
  var _useContext = useContext(ScrollableContentContext),
    scrollContainerRef = _useContext.scrollContainerRef;
  var finalClassName = classNames((_classNames = {
    content: true,
    'scrollable-content-content': true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, 'hide-scrollbar', hideScrollbar), _classNames));
  return /*#__PURE__*/React.createElement("div", {
    className: finalClassName,
    ref: scrollContainerRef
  }, finalContent);
}
Content.defaultProps = defaultProps;